<template>
  <div class="container">
    <div v-for="property in properties" :key="property.id">
      <api-schema-property
        v-if="property.schema"
        :parameter="property.id"
        :schema="property.schema"
        :required="property.required"
        :default-expanded="defaultExpanded"
        :custom-property-tag="'xCustomPropertyTag' in property ? property.xCustomPropertyTag : undefined"
        :custom-version-tag="'xCustomVersionTag' in property ? property.xCustomVersionTag : undefined"
      >
        <template #description>
          <html-text
            v-if="property.schema.description"
            tag="span"
            :html="property.schema.description"
            class="text-break"
          />
        </template>
      </api-schema-property>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SchemaProperty } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import HtmlText from '@/components/utils/HtmlText.vue';
import ApiSchemaProperty from '@/components/api/content/operations/schema/ApiSchemaProperty.vue';

withDefaults(
  defineProps<{
    properties: SchemaProperty[];
    // if true, nested schema sections start expanded
    defaultExpanded?: boolean;
  }>(),
  { defaultExpanded: true }
);
</script>

<style scoped lang="scss">
.container {
  padding: 8px 0;
}
.text-break {
  @media screen and (max-width: $mobile-large) {
    word-break: break-word;
  }
}
</style>
